var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTShirtAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19785 3H6.75786C5.56 3 4.38894 3.35058 3.39223 4.00756L2.45042 4.62835C2.10942 4.85312 1.93931 5.25918 2.01968 5.65655L2.6735 8.88908C2.7928 9.47891 3.40789 9.83187 3.98498 9.64166L5.93211 8.99987V19C5.93211 20.1046 6.83767 21 7.95474 21H16.0453C17.1623 21 18.0679 20.1046 18.0679 19V8.99987L20.015 9.64166C20.5921 9.83187 21.2072 9.47891 21.3265 8.88908L21.9803 5.65655C22.0607 5.25918 21.8906 4.85313 21.5496 4.62835L20.6078 4.00756C19.6111 3.35058 18.44 3 17.2421 3H16.8021C16.7469 5.12777 15.2632 6.96646 13.1651 7.48512C12.4001 7.67422 11.5999 7.67422 10.8349 7.48512C8.73681 6.96646 7.25311 5.12777 7.19785 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2642 3.25854C13.1338 3.88093 10.8662 3.88093 8.73584 3.25854C8.89381 4.58577 9.86607 5.69943 11.2028 6.02989C11.7262 6.15927 12.2738 6.15927 12.7972 6.02989C14.1339 5.69943 15.1062 4.58577 15.2642 3.25854Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirtAlt);
export default __webpack_public_path__ + "static/media/t-shirt-alt.4c4049c1f19aa45c1cecbf89e4665960.svg";
export { ForwardRef as ReactComponent };